import { StoredMaterialsCarryoverType } from '../enums.js'

export const OPT_OUT_REASON_MAX_CHARS = 1000
export const DEFAULT_CONTRACT_RETENTION_PERCENT = 0.1
export const DEFAULT_DUE_TO_GC_DAY_OF_MONTH = 28
// Sentinel value stored in payAppDueOnDayOfMonth to mean "last day of the month"
export const END_OF_MONTH_DAY_OF_MONTH = 0
export const DEFAULT_DAYS_BEFORE_PAY_APP_DUE = 3
export const MAX_DAYS_BEFORE_PAY_APP_DUE = 15
export const DEFAULT_STORED_MATERIALS_CARRYOVER_TYPE = StoredMaterialsCarryoverType.AUTOMATIC

/**
 * Collections reminder emails need the contract's payment terms (days until payment is due) to
 * compute the payment due date. When unset, reminders are skipped rather than assuming a default.
 */
export function isMissingPaymentTermsForCollections({
  paymentTerms,
}: {
  paymentTerms: number | null
}): boolean {
  return paymentTerms === null || paymentTerms === 0
}
